import { PdfViewerComponent } from '@syncfusion/ej2-react-pdfviewer';
import React from 'react';
import { FitType, IFormInteractionHandler } from './IFormInteractionHandler';

export class PdfFormInteractionHandler implements IFormInteractionHandler {
    constructor(private pdfViewer: React.RefObject<PdfViewerComponent>) {}

    getCurrentPage(): number {
        return this.pdfViewer.current?.currentPageNumber ?? 1;
    }

    getTotalPages(): number {
        return this.pdfViewer.current?.pageCount || 1;
    }

    goToPage(pageNumber: number): void {
        this.pdfViewer.current?.navigation.goToPage(pageNumber);
    }

    goToPreviousPage(): void {
        this.pdfViewer.current?.navigation.goToPreviousPage();
    }

    goToNextPage(): void {
        this.pdfViewer.current?.navigation.goToNextPage();
    }

    goToFirstPage(): void {
        this.pdfViewer.current?.navigation.goToFirstPage();
    }

    goToLastPage(): void {
        this.pdfViewer.current?.navigation.goToLastPage();
    }

    zoomIn(): number {
        this.pdfViewer.current?.magnification.zoomIn();
        return this.pdfViewer.current?.magnification.zoomFactor ?? 1;
    }

    zoomOut(): number {
        this.pdfViewer.current?.magnification.zoomOut();
        return this.pdfViewer.current?.magnification.zoomFactor ?? 1;
    }

    zoomTo(zoomPercentage: number): void {
        this.pdfViewer.current?.magnification.zoomTo(zoomPercentage);
    }

    fitToPage(): void {
        this.pdfViewer.current?.magnification.fitToPage();
    }

    fitToWidth(): void {
        this.pdfViewer.current?.magnification.fitToWidth();
    }

    fitToAuto(): void {
        this.pdfViewer.current?.magnification.fitToAuto();
    }

    getCurrentFitType(): FitType {
        const fitType = this.pdfViewer.current?.magnification.fitType;

        if (fitType === 'fitToPage') return 'fitToPage';
        if (fitType === 'fitToWidth') return 'fitToWidth';
        if (fitType === 'fitToAuto') return 'fitToAuto';

        return null;
    }
}
